<template>
  <v-container id="edit-form" fluid>
    <v-card class="sv-card">
      <card-content
        v-resize="onResize"
        :style="{ height: height(170) }"
        class="overflow-y-auto px-0"
      >
        <div class="py-4 px-6">
          <validation-observer ref="validator">
            <v-row>
              <v-col cols="11" md="6">
                <v-text-field
                  id="form-text-input-title"
                  v-model="formData.title"
                  label="Имя"
                  outlined
                  dense
                  hide-details
                />
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="11" md="6">
                <v-combobox
                  id="form-autocomplete-company"
                  v-model="formData.company"
                  :items="dics.companies"
                  label="Компания"
                  outlined
                  dense
                  hide-details
                  :cache-items="false"
                  @blur="onCompanyBlur"
                ></v-combobox>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="11" md="6">
                <v-text-field
                  id="form-text-input-position"
                  v-model="formData.position"
                  label="Должность"
                  outlined
                  dense
                  hide-details
                />
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="11" md="6">
                <v-text-field
                  id="form-text-input-location"
                  v-model="formData.location"
                  label="Локация"
                  outlined
                  dense
                  hide-details
                />
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="11" md="6">
                <v-textarea
                  id="form-text-input-phones"
                  v-model="formData.phones"
                  label="Телефон"
                  outlined
                  dense
                  hide-details
                  rows="4"
                />
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="11" md="6">
                <v-textarea
                  id="form-text-input-emails"
                  v-model="formData.emails"
                  label="Email"
                  outlined
                  dense
                  hide-details
                  rows="4"
                />
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="11" md="6">
                <image-editor
                  v-model="formData.photo"
                  :tag="{
                    name: 'photo',
                    description: 'Фото',
                    custom_settings: {}
                  }"
                  :readonly="readonly"
                />
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="11" md="6">
                <file-editor
                  v-model="formData.file"
                  :tag="{
                    name: 'file',
                    description: 'Рабочий файл',
                    custom_settings: {}
                  }"
                  :readonly="readonly"
                />
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="11" md="6">
                <tags-editor
                  id="form-autocomplete-tags"
                  v-model="formData.tags"
                  :tag="{
                    name: 'tags',
                    description: 'Тэги',
                    custom_settings: {}
                  }"
                  :dic="dic"
                />
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="11" md="6">
                <div
                  id="form-select-contacted-user-container"
                  class="select-container"
                >
                  <v-select
                    id="form-select-contacted-user"
                    v-model="formData.contacted_user"
                    label="Кто контактировал"
                    outlined
                    dense
                    multiple
                    :items="dics.users"
                    item-text="name"
                    item-value="id"
                    :attach="`#form-select-contacted-user-container`"
                    :menu-props="{
                      contentClass: 'kk-nudge-manual'
                    }"
                    hide-details
                    :readonly="readonly"
                    :value-comparator="(a, b) => a == b"
                  />
                </div>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="11" md="6">
                <v-autocomplete
                  id="form-select-contacted-user"
                  v-model="formData.qr_codes"
                  label="QR-сувениры"
                  :items="dics.qr_codes"
                  multiple
                  dense
                  outlined
                  chips
                  deletable-chips
                  small-chips
                  :readonly="readonly"
                  item-text="text"
                  item-value="id"
                  class="sv-autocomplete"
                  hide-details
                />
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="11" md="6">
                <v-textarea
                  id="form-text-input-whats-done"
                  v-model="formData.whats_done"
                  label="Что сделано"
                  outlined
                  dense
                  hide-details
                  rows="6"
                />
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="11" md="6">
                <v-textarea
                  id="form-text-input-comment"
                  v-model="formData.comment"
                  label="Комментарий"
                  outlined
                  dense
                  hide-details
                  rows="6"
                />
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="11" md="6">
                <datetime-field
                  id="form-date-field-last-contact"
                  v-model="formData.last_contact"
                  label="Последний контакт (дата)"
                  format="DD.MM.yyyy"
                  outlined
                  dense
                  hide-details
                  :readonly="readonly"
                />
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="11" md="6">
                <datetime-field
                  id="form-date-field-next-contact"
                  ref="nextcontact"
                  v-model="formData.next_contact"
                  label="Следующий контакт (дата)"
                  format="DD.MM.yyyy"
                  outlined
                  dense
                  hide-details
                  :readonly="readonly"
                />
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="11" md="6">
                <div
                  id="form-select-account-container"
                  class="select-container"
                >
                  <v-select
                    id="form-select-account"
                    v-model="formData.account"
                    label="Аккаунт"
                    outlined
                    dense
                    :items="dics.users"
                    item-text="name"
                    item-value="id"
                    :attach="`#form-select-account-container`"
                    :menu-props="{
                      top: true,
                      offsetY: true
                    }"
                    hide-details
                    :readonly="readonly"
                    :value-comparator="(a, b) => a == b"
                  />
                </div>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="11" md="6">
                <div id="form-select-status-container" class="select-container">
                  <v-select
                    id="form-select-status"
                    v-model="formData.status"
                    label="Статус"
                    outlined
                    dense
                    :items="dics.crm_contact_statuses"
                    item-text="value"
                    item-value="term"
                    :attach="`#form-select-status-container`"
                    :menu-props="{
                      top: true,
                      offsetY: true
                    }"
                    hide-details
                    :readonly="readonly"
                    :value-comparator="(a, b) => a == b"
                    @change="onStatusChange"
                  />
                </div>
              </v-col>
            </v-row>
          </validation-observer>
        </div>
      </card-content>
      <card-actions>
        <v-btn
          id="form-btn-cancel"
          color="primary"
          depressed
          outlined
          @click="onClickClose"
        >
          {{ readonly ? "Закрыть" : "Отменить" }}
        </v-btn>
        <v-btn
          v-if="!readonly"
          id="form-btn-save"
          color="primary"
          depressed
          outlined
          :disabled="loading"
          @click="onClickSave(false)"
        >
          Сохранить
        </v-btn>
        <v-btn
          v-if="!readonly"
          id="form-btn-save"
          color="primary"
          depressed
          :disabled="loading"
          @click="onClickSave(true)"
        >
          Сохранить и закрыть
        </v-btn>
        <v-spacer />
        <v-btn
          v-if="!readonly && !!id"
          id="form-btn-delete"
          color="red"
          depressed
          outlined
          :disabled="loading"
          @click="onClickDelete"
        >
          Удалить
        </v-btn>
      </card-actions>
    </v-card>
  </v-container>
</template>
<script>
import { cloneDeep } from "lodash";
import CheckPermissionMixin from "@/mixins/CheckPermissionMixin";
import NotificationMixin from "@/mixins/NotificationMixin";
import ResizeMixin from "@/mixins/ResizeMixin";
import Repository from "@/api/special/crm-contacts.js";
import TagsEditor from "@/pages/Node/Editors/TagsEditor.vue";
import ImageEditor from "@/pages/Node/Editors/ImageEditor.vue";
import FileEditor from "@/pages/Node/Editors/FileEditor.vue";
import DatetimeField from "@/components/DatetimeField.vue";
import DialogMixin from "@/mixins/DialogMixin";

const formDataFactory = myId => ({
  title: "",
  company: "",
  position: "",
  location: "",
  phones: "",
  emails: "",
  photo: "",
  file: "",
  tags: [],
  source: "manual",
  contacted_user: [myId],
  qr_codes: [],
  whats_done: "",
  last_contact: "",
  next_contact: "",
  account: myId,
  status: "contact"
});

export default {
  components: {
    TagsEditor,
    FileEditor,
    ImageEditor,
    DatetimeField
  },
  mixins: [ResizeMixin, NotificationMixin, CheckPermissionMixin, DialogMixin],

  props: {
    id: {
      type: [Number, String],
      default: null
    }
  },

  data() {
    return {
      loading: false,
      formData: formDataFactory(""),
      dics: {
        crm_contact_statuses: [],
        crm_contact_sources: [],
        qr_tags: [],
        qr_codes: [],
        users: [],
        companies: []
      }
    };
  },

  computed: {
    readonly() {
      return !this.$can("CrmContacts/edit");
    },
    dic() {
      const dic = this.$store.getters.getDicNames.find(
        dic => dic.name == "qr_tags"
      );
      return this.$store.getters.getDic(dic.id, "en");
    }
  },

  async created() {
    this.resetForm();
    if (this.id) {
      await this.$store.dispatch("fetchCurrentNode", this.id);
    }
    await this.$nextTick();
    this.loadItem();
  },

  methods: {
    getTitle(id) {
      const nodeData = this.$store.getters.getNodeFromAnyCache(id) || {};
      return nodeData?.t?.en || `ID ${id}`;
    },
    async loadItem() {
      try {
        if (!this.id) {
          this.resetForm();
        }
        this.loading = true;
        const { data } = this.id
          ? await Repository.getOne(this.id)
          : await Repository.getCreateTemplate();
        this.dics.crm_contact_statuses = data.dics.crm_contact_statuses;
        this.dics.crm_contact_sources = data.dics.crm_contact_sources;
        this.dics.qr_tags = data.dics.qr_tags;
        this.dics.qr_codes = data.qrCodes;
        this.dics.users = data.users;
        this.dics.companies = data.companies;
        if (this.id) {
          this.formData = data.formData;
        } else {
          this.$set(this.formData, "last_contact", data.formData.last_contact);
          this.$set(this.formData, "next_contact", data.formData.next_contact);
        }
      } catch (error) {
        return true;
      } finally {
        this.loading = false;
      }
    },

    async onClickSave(close) {
      try {
        if (!(await this.$refs.validator.validate())) {
          const elErrm = document.querySelector(
            ".v-messages.error--text:first-of-type"
          );
          if (elErrm) {
            const elRow = elErrm.closest(".row");
            if (elRow) {
              elRow.scrollIntoView();
            }
          }
          return false;
        }

        const companyEl = document.getElementById("form-autocomplete-company");
        if (companyEl) {
          companyEl.blur();
          await this.$nextTick();
        }

        this.loading = true;

        const { formData, id } = this;

        const payload = cloneDeep(formData);

        const { data } = id
          ? await Repository.update(id, payload)
          : await Repository.create(payload);

        if (close) {
          this.onClickClose();
        } else if (!id && data.id) {
          this.$router.push({
            name: "CrmContactsEdit",
            params: { id: data.id }
          });
        } else {
          this.refreshCompanies();
        }

        this.sendAlert(data.alert);
      } finally {
        this.loading = false;
      }
    },

    onClickClose() {
      this.$router.push({ name: "CrmContacts" });
    },

    onCompanyBlur(v) {
      this.formData.company = v.srcElement.value;
    },

    async refreshCompanies() {
      const { data } = await Repository.getCreateTemplate();
      this.$set(this.dics, "companies", data.companies);
    },

    async onClickDelete() {
      const confirm = await this.confirm(
        "Удаление CRM-контакта",
        "Вы действительно хотите удалить этот контакт? Это действие нельзя отменить!",
        {
          width: 550
        }
      );
      if (!confirm) return;
      try {
        const { data } = await Repository.delete(this.id);
        this.onClickClose();
        this.sendAlert(data.alert);
      } catch (error) {
        return true;
      }
    },

    resetForm() {
      this.formData = formDataFactory(this.$store.getters.getMyId);
      if (this.$refs.validator) this.$refs.validator.reset();
    },

    onStatusChange(e) {
      if (e == "archive" || e == "lead") {
        this.formData.next_contact = "";
        this.$nextTick(() => {
          this.formData.next_contact = "";
        });
      }
    }
  }
};
</script>
<style scoped>
.select-container {
  position: relative;
}
::v-deep .kk-nudge-manual {
  top: 100% !important;
}
</style>
